import { useLocation } from '@frontend/weave-router';

/**
 * Custom hook to detect if the calendar page is currently open/active
 * @returns {boolean} - true if currently on the calendar page, false otherwise
 */
export const useIsCalendarPageOpen = (): boolean => {
  const { pathname } = useLocation();

  // Check if the current pathname starts with '/schedule/calendar'
  // This covers all calendar routes like:
  // - /schedule/calendar
  // - /schedule/calendar?tab=...
  // - Any other calendar sub-routes
  const isScheduleCalendarOpen = pathname.startsWith('/schedule/calendar');

  return isScheduleCalendarOpen;
};
